/**
 * =============================================================================
 * AUTH GATE — tokenless "open from BigCommerce" screen (ADR-025 §7.2 / M1, B-1)
 * =============================================================================
 *
 * ONE clean screen rendered when the admin loads without a BigCommerce session
 * token — replacing the legacy "ragged tokenless multi-panel fallback" (every
 * panel individually rendering its own please-log-in / null state). Shown for
 * BOTH shell modes: the release-flag read itself requires a token, so an
 * unauthenticated load never reaches either surface and fires NO requests
 * (M1: unauthenticated → single gate screen, no section fetches).
 *
 * The post-install success handoff is a SEPARATE screen with its own caller
 * contract (`InstalledSuccessScreen`) — `AdminApp` checks it first.
 * =============================================================================
 */

import React from 'react';
import { Box, H2, Panel, Text } from '@bigcommerce/big-design';

export function AuthGate(): React.ReactElement {
  return (
    <Box padding="large" data-testid="admin-auth-gate">
      <Panel>
        <Box padding="large">
          <H2>Open Find My Part from BigCommerce</H2>

          <Text>
            This dashboard needs a signed BigCommerce session, and none was found
            on this page load.
          </Text>

          <Text marginTop="medium">
            In your BigCommerce control panel, go to <strong>Apps → Find My
            Part</strong>. BigCommerce will sign you in with a fresh session
            token automatically.
          </Text>

          <Text marginTop="medium" color="secondary">
            Sessions are issued by BigCommerce when the app is opened from the
            control panel and are never stored by this page — reloading or
            bookmarking this URL directly will always land here.
          </Text>
        </Box>
      </Panel>
    </Box>
  );
}
